import { useState } from "react";
import { Eye, EyeOff, KeyRound, Link2 } from "lucide-react";
import { api } from "@/lib/api";
import { CardTitle, Field, useSave } from "./ProfileCard";

function Secret({ label, value, onChange, id, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <Field label={label} hint={props.hint}>
      <span className="as-secret">
        <input type={show ? "text" : "password"} value={value} onChange={(e) => onChange(e.target.value)} required data-testid={id} {...props} />
        <button type="button" onClick={() => setShow(!show)} aria-label={show ? "Hide password" : "Show password"} data-testid={`${id}-eye`}>
          {show ? <EyeOff size={15} /> : <Eye size={15} />}
        </button>
      </span>
    </Field>
  );
}

export function PasswordCard({ data, onSaved }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, run] = useSave();
  const mismatch = confirm && next !== confirm;
  const submit = async (e) => {
    e.preventDefault();
    if (mismatch) return;
    const ok = await run(() => api.post("/account/password", { current_password: current || null, new_password: next }),
      data.has_password ? "Password changed" : "Password set");
    if (ok) {
      setCurrent(""); setNext(""); setConfirm("");
      if (!data.has_password) onSaved({ ...data, has_password: true });
    }
  };
  return (
    <section className="as-card" data-testid="security-card">
      <CardTitle icon={KeyRound}>{data.has_password ? "Change password" : "Set a password"}</CardTitle>
      <form className="as-fields" onSubmit={submit} data-testid="password-form">
        {data.has_password && <Secret label="Current password" value={current} onChange={setCurrent} id="current-password-input" autoComplete="current-password" />}
        <Secret label="New password" value={next} onChange={setNext} id="new-password-input" minLength={8} maxLength={128} autoComplete="new-password" hint="At least 8 characters" />
        <Secret label="Confirm new password" value={confirm} onChange={setConfirm} id="confirm-password-input" autoComplete="new-password" />
        {mismatch && <p className="as-error" data-testid="password-mismatch">Passwords do not match</p>}
        <button className="as-primary" disabled={busy || mismatch} data-testid="password-save-btn">{data.has_password ? "Update password" : "Set password"}</button>
      </form>
    </section>
  );
}

export function ConnectedCard({ data }) {
  return (
    <section className="as-card" data-testid="connected-card">
      <CardTitle icon={Link2}>Connected accounts</CardTitle>
      <div className="as-connected" data-testid="google-status">
        <span className="as-g">G</span>
        <div><b>Google</b><small className={data.google_linked ? "is-on" : ""}>{data.google_linked ? "Connected" : "Not connected"}</small></div>
      </div>
      <p className="as-muted">
        {data.google_linked
          ? "You can sign in with Google or with your email and password."
          : "Sign in once with Google using this same email to connect it."}
      </p>
    </section>
  );
}
